export const ArrowRightIcon = ({ className = "" }: { className?: string }) => {
	return (
		<svg
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			fill="currentColor"
		>
			<path
				stroke="none"
				d="M0 0h24v24H0z"
				fill="none"
			/>
			<path d="M5 12l14 0" />
			<path d="M13 18l6 -6" />
			<path d="M13 6l6 6" />
		</svg>
	);
};
